import React from 'react';
import { Box, Button, Container, Flex, Link, useColorMode, useColorModeValue } from '@chakra-ui/react';
import { MoonIcon, SunIcon } from '@chakra-ui/icons';
import { motion } from 'framer-motion';

const MotionBox = motion(Box);
const MotionFlex = motion(Flex);

const NavLink = ({ children, href }) => {
  const handleClick = (e) => {
    e.preventDefault();
    const target = document.querySelector(href);
    if (target) {
      target.scrollIntoView({
        behavior: 'smooth',
        block: 'start',
      });
    }
  };

  return (
    <Link
      px={2}
      py={1}
      fontWeight="medium"
      color={useColorModeValue('gray.600', 'gray.400')}
      _hover={{
        textDecoration: 'none',
        color: useColorModeValue('black', 'white'),
      }}
      href={href}
      onClick={handleClick}
    >
      {children}
    </Link>
  );
};

export default function Navbar() {
  const { colorMode, toggleColorMode } = useColorMode();
  const bgColor = useColorModeValue('white', 'black');

  return (
    <MotionBox
      bg={bgColor}
      py={4}
      position="sticky"
      top="0"
      zIndex="sticky"
      initial={{ opacity: 0, y: -50 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.5 }}
    >
      <Container maxW="container.xl">
        <MotionFlex
          alignItems="center"
          justifyContent="flex-end"
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ delay: 0.2, duration: 0.5 }}
        >
          <Flex alignItems="center" gap={6}>
            <NavLink href="#projects">Progetti</NavLink>
            <NavLink href="#journey">Percorso</NavLink>
            <Button onClick={toggleColorMode} variant="ghost" size="sm" p={0}>
              {colorMode === 'light' ? <MoonIcon /> : <SunIcon />}
            </Button>
          </Flex>
        </MotionFlex>
      </Container>
    </MotionBox>
  );
}